module.exports = __webpack_public_path__ + "141d4a85/img/file-icon.c085e21e.svg";